import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import NavLinks from "../Navbar/NavLinks";
// import MUCLogoCompact from "../MUCLogoCompact";
import MUCLogo from "../MucLogo";

const NavBar = () => {
  const [top, setTop] = useState(true);
  const [isOpen, setisOpen] = React.useState(false);
  const sideNavRef = useRef(null);
  function handleClick(event) {
    setisOpen(!isOpen);
  }

  const handleMnuScrollClick = () => {
    setisOpen(false);
  };

  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true);
    };
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, [top]);

  useEffect(() => {
    // Add event listener to the document object
    document.addEventListener("mousedown", handleClickOutside);

    // Remove event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function handleClickOutside(event) {
    if (sideNavRef.current && !sideNavRef.current.contains(event.target)) {
      setisOpen(false);
    }
  }
  return (
    <nav
      ref={sideNavRef}
      className={`fixed top-0 w-screen z-30 p-2 lg:mx-auto transition duration-300 ease-in-out mb-16 ${
        !top && "bg-white shadow-lg"
      }`}
    >
      <div className="container mx-auto items-center flex flex-wrap">
        <div className="ml-2 hidden lg:block pr-6">
          <Link to="/">
            <MUCLogo width="80" height="80" />
          </Link>
        </div>
        <div className="ml-2 lg:hidden sm:block pr-5">
          <Link to="/">
            <MUCLogo width="50" height="50" />
          </Link>
        </div>
        <div className="flex flex-grow mx-auto items-center text-center font-semibold">
          <Link to="/">
            <span className="font-extrabold text-base sm:text-xl md:text-2xl lg:text-2xl xl:text-4xl text-blue-900">
              Multi Utama Consultant
            </span>
          </Link>
        </div>
        <div className="lg:flex bg-white lg:bg-opacity-0 lg:shadow-none flex-row-reverse">
          <button
            className="mr-2 rounded-lg lg:hidden text-blue-900"
            onClick={handleClick}
          >
            <svg
              className="h-6 w-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              {isOpen && (
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                />
              )}
              {!isOpen && (
                <path
                  fillRule="evenodd"
                  d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                />
              )}
            </svg>
          </button>
          <div className="hidden space-x-6 lg:inline-block p-5">
            <NavLinks
              handleMnuScrollClick={() => {
                handleMnuScrollClick();
              }}
            />
          </div>

          <div
            className={`fixed transition-transform duration-300 ease-in-out transit flex justify-center left-0 w-full h-auto rounded-md p-10 bg-white rounded-lg lg:hidden shadow-xl top-14 ${
              isOpen ? "block" : "hidden"
            } `}
          >
            <div className="flex flex-col space-y-6">
              <NavLinks
                handleMnuScrollClick={() => {
                  handleMnuScrollClick();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
